"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayTime = void 0;
/**
 * Times of the day
 */
var DayTime;
(function (DayTime) {
    DayTime["MORNING"] = "MORNING";
    DayTime["NOON"] = "NOON";
    DayTime["AFTERNOON"] = "AFTERNOON";
})(DayTime = exports.DayTime || (exports.DayTime = {}));
//# sourceMappingURL=DayTime.js.map